<div class="flex flex-col gap-3">
	<div class="flex justify-between">
		<h4><strong>Editing Tag:</strong> {{ tagLabel }}</h4>
		<p class="cursor-pointer font-bold" (click)="reset()">Reset</p>
	</div>
	<div>
		<app-html-mini-editor
			class="mceNonEditable"
			[debounceTime]="0"
			[document]="tagValue"
			(onChange)="onChange($event)"
			minHeight="400px"
		></app-html-mini-editor>
	</div>
	<div class="flex justify-between">
		<app-button btn="tertiary" size="small" (click)="closeModal()"
			>Cancel</app-button
		>
		<app-button size="small" (click)="save()">Save</app-button>
	</div>
</div>
